import { z } from "zod";
import {
    OutboundEmailBlockReason,
    OutboundEmailReason,
    OutboundEmailStatus,
} from "../../../types/domains/outboundEmail";

export const invoiceUndeliveredSendSchema = z.object({
    status: z.nativeEnum(OutboundEmailStatus),
    blockReason: z.nativeEnum(OutboundEmailBlockReason).nullable(),
    attemptedAt: z.coerce.date(),
});

export const invoiceSentInfoSchema = z.object({
    sentAt: z.coerce.date().nullable(),
    sentReason: z.nativeEnum(OutboundEmailReason).nullable(),
    sentByUserId: z.number().nullable(),
    sentByName: z.string().nullable(),
    isSendScheduled: z.boolean(),
    lastUndeliveredSend: invoiceUndeliveredSendSchema.nullable(),
});

export type InvoiceSentInfo = z.infer<typeof invoiceSentInfoSchema>;
